import { z } from 'zod'

export const LrrReferenceMetadataResponseSchema = z.object({
  s3_path: z.string(),
  slug: z.string(),
  title: z.string(),
  citation: z.string(),
  jurisdiction_code: z.string(),
  doc_type: z.string(), // statute, regulation, rule
  currency: z.string().nullable(), // date the source was refreshed by provider
  effective_date: z.string().nullable(), // date the law was enacted
})
export type LrrReferenceMetadataResponse = z.infer<typeof LrrReferenceMetadataResponseSchema>

export const LrrReferenceHtmlResponseSchema = z.object({
  data: z.string(),
})
export type LrrReferenceHtmlResponse = z.infer<typeof LrrReferenceHtmlResponseSchema>

// Loose like the chat contract: an unrecognised status must render nothing rather than
// fail validation. `null` means "say nothing" and is the common case.
export const LrrContentStatusResponseSchema = z.object({
  content_status: z.string().nullish(),
})
export type LrrContentStatusResponse = z.infer<typeof LrrContentStatusResponseSchema>
